import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

export const LanguageToggle = ({ testId = "language-toggle" }) => {
  const { lang, setLang, languages } = useLang();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid={testId} className="gap-1.5">
          <Globe className="h-4 w-4" />
          <span className="font-medium">{current.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={lang === l.code ? "bg-secondary" : ""}
          >
            <span className="mr-2 text-xs font-semibold text-muted-foreground">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
